import React, { useEffect, useState } from "react";
import { Col, Container, Row, Card, Button, Form } from "react-bootstrap";
import callImg from "../assets/images/contactus/call.svg";
import mailImg from "../assets/images/contactus/mail.svg";
import locationImg from "../assets/images/contactus/location.svg";
import PersonCard from "../components/contactus/PersonCard";
import { clearError, validateData } from "../validators/YupValidations";
import { contactUsSchema } from "../validators/validatorSchema";
import { useSelector } from "react-redux";
import SelectField from "../components/common/SelectField";
import API from "../config/axios";
import { api_paths } from "../config/api.paths";
import { toastErrorMessage, toastSuccessMessage } from "../utils/utils";
import defaultAvatar from "../assets/images/contactus/defaultavatar.png";
import { useDispatch } from "react-redux";
import { SET_LOADING } from "../redux/user";
import { formatUSPhone, normalizePhoneForSave } from "../utils/phoneFormat";
import { useNavigate } from "react-router-dom";

const Contactcarddetails = [
  { id: 1, title: "Phone", text: "+1 (865) 771-9190", img: callImg },
  {
    id: 2,
    title: "Email",
    text: "gujaratisamajoftampabay@gmail.com",
    img: mailImg,
  },
  {
    id: 3,
    title: "Address",
    text: "5513 Lynn Road, Tampa, FL 33624",
    img: locationImg,
  },
];
const IMG_PATH = process.env.REACT_APP_IMAGE_BASEURL || "";

export default function ContactUs() {
  const { user } = useSelector((state) => state.USER_DATA);

  const [committeMembers, setCommitteMembers] = useState([]);

  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    countryCode: "+1",
    phone: "",
    message: "",
  });

  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  const countryCodeOptions = [
    { value: "+1", label: "+1" },
    { value: "+91", label: "+91" },
  ];

  useEffect(() => {
    if (user) {
      setFormData((prev) => ({
        ...prev,
        email: user.email || "null",
        full_name: `${user.first_name || ""} ${user.last_name || ""}`.trim(),
        phone:
          user.country_code === "+1"
            ? formatUSPhone(user.phone || "")
            : user.phone || "",
        countryCode: user.country_code,
      }));
    }
  }, [user]);

  const fetchCommiteeMembers = async () => {
    dispatch(SET_LOADING(true));
    try {
      const response = await API.get(api_paths.member.CONTACT_US.COMMITTEE);
      // console.log("Committee List:", response.data);

      const data = response.data?.payload?.result?.data || [];
      const executiveMembers = data.filter(
        (m) => m.is_board_of_governor === false
      );
      setCommitteMembers(executiveMembers);
    } catch (error) {
      console.error("Error fetching events:", error);
    } finally {
      dispatch(SET_LOADING(false));
    }
  };

  const handleChange = (field, value) => {
    if (field === "phone") {
      if (formData.countryCode === "+1") {
        // keep max 10 digits
        const digits = value.replace(/\D/g, "").slice(0, 10);
        value = formatUSPhone(digits); // format for display
      } else {
        value = value.replace(/\D/g, "").slice(0, 15); // other countries: digits only
      }
    }

    setFormData((prev) => ({ ...prev, [field]: value }));

    if (errors[field]) clearError(setErrors, field);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formForValidation = {
      ...formData,
      phone:
        formData.countryCode === "+1"
          ? normalizePhoneForSave(formData.phone)
          : formData.phone.replace(/\D/g, ""),
    };

    const isValid = await validateData(
      contactUsSchema,
      formForValidation,
      setErrors
    );
    if (!isValid) return;

    try {
      setSubmitting(true);

      const obj = {
        full_name: formData.full_name,
        email: formData.email,
        country_code: formData.countryCode,
        phone: formForValidation.phone,
        message: formData.message,
      };

      console.log("Submitting RSVP with data:", obj);

      const response = await API.post(api_paths.member.CONTACT_US.FORM, obj);

      console.log("RSVP Response:", response.data);

      setFormData({
        full_name: "",
        email: "",
        countryCode: "+1",
        phone: "",
        message: "",
      });

      toastSuccessMessage(response?.data?.message);

      setSubmitting(false);
      //   navigate("/");
    } catch (error) {
      toastErrorMessage("Failed to submit RSVP. Please try again.");
      setSubmitting(false);
      // console.error("Error submitting RSVP:", error);
    } finally {
      setSubmitting(false);
    }
  };
  const navigate = useNavigate();
  useEffect(() => {
    fetchCommiteeMembers();
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <section>
        <Container>
          <Row>
            <Col md={12} className="mt-5 contact-header text-center">
              <h1 className="h1">Contact Us</h1>
              <p>
                We'd love to hear from you. Please fill out the form below and
                we'll get back to you as soon as possible.
              </p>
            </Col>
          </Row>
          <hr />
        </Container>
      </section>

      <section className="contact-details-card py-4">
        <Container>
          <Row className="g-4">
            {Contactcarddetails.map((item) => (
              <Col key={item.id} lg={4} md={6} sm={12}>
                <Card className="contact-card h-100 border-0 p-3">
                  <Card.Body className="d-flex align-items-center gap-3 p-0">
                    <div className="icon-wrap d-flex align-items-center justify-content-center">
                      <img
                        src={item.img}
                        alt={item.title}
                        className="contactcard-icon"
                      />
                    </div>

                    <div className="contact-text">
                      <Card.Title className="mb-1 fw-semibold">
                        {item.title}
                      </Card.Title>
                      <Card.Text className="fw-normal mb-0 text-muted small">
                        {item.title === "Email" ? (
                          <a
                            href={`mailto:${item.text}`}
                            className="text-muted text-decoration-none"
                          >
                            {item.text}
                          </a>
                        ) : item.title === "Phone" ? (
                          <a
                            href={`tel:${item.text}`}
                            className="text-muted text-decoration-none"
                          >
                            {item.text}
                          </a>
                        ) : (
                          item.text
                        )}
                      </Card.Text>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="contact-info overflow-x-hidden">
        <Container className="my-3">
          <Row className="gy-4 gx-5">
            {/* LEFT: Form */}
            <Col lg={6}>
              <Card className="contact-form p-md-3 p-1">
                <Card.Body>
                  <Card.Title className="fw-bold">Get In Touch</Card.Title>
                  <Card.Text>
                    Please fill out our Contact Form below and we will contact
                    you at earliest.
                  </Card.Text>

                  <Form onSubmit={handleSubmit} noValidate>
                    <Form.Group className="mb-3" controlId="fullName">
                      <Form.Label className="form-label-required">
                        Full Name <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        name="fullName"
                        type="text"
                        placeholder="Enter full name"
                        value={formData.full_name}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            full_name: e.target.value,
                          });
                          errors.full_name &&
                            clearError(setErrors, "full_name");
                        }}
                        className="form-control"
                      />
                      {errors.full_name && (
                        <Form.Text className="text-danger">
                          {errors.full_name.message}
                        </Form.Text>
                      )}
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="email">
                      <Form.Label>Email (Optional)</Form.Label>
                      <Form.Control
                        name="email"
                        type="email"
                        placeholder="Enter email id"
                        value={formData.email}
                        onChange={(e) => {
                          setFormData({ ...formData, email: e.target.value });
                          errors.email && clearError(setErrors, "email");
                        }}
                        className="form-control"
                      />
                      {errors.email && (
                        <Form.Text className="text-danger">
                          {errors.email.message}
                        </Form.Text>
                      )}
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="phone">
                      <Form.Label className="form-label-required">
                        Contact Number <span className="text-danger">*</span>
                      </Form.Label>
                      <Row className="g-2">
                        <Col xs={4} md={3}>
                          <SelectField
                            value={countryCodeOptions.find(
                              (opt) => opt.value === formData.countryCode
                            )}
                            options={countryCodeOptions}
                            onChange={(opt) => {
                              const newCode = opt.value;
                              setFormData((prev) => ({
                                ...prev,
                                countryCode: newCode,
                                phone:
                                  newCode === "+1"
                                    ? formatUSPhone(
                                      normalizePhoneForSave(prev.phone)
                                    )
                                    : prev.phone.replace(/\D/g, ""),
                              }));
                            }}
                          />
                        </Col>

                        <Col xs={8} md={9}>
                          <Form.Control
                            type="tel"
                            placeholder="Enter your phone number"
                            value={formData.phone}
                            onChange={(e) =>
                              handleChange("phone", e.target.value)
                            }
                            maxLength={formData.countryCode === "+1" ? 15 : 10}
                          />
                        </Col>
                      </Row>

                      {errors.phone && (
                        <Form.Text className="text-danger">
                          {errors.phone.message}
                        </Form.Text>
                      )}
                    </Form.Group>

                    <Form.Group className="mb-4" controlId="message">
                      <Form.Label className="form-label-required">
                        Your Message <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        name="message"
                        as="textarea"
                        rows={6}
                        placeholder="Enter your message"
                        value={formData.message}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            message: e.target.value,
                          });
                          errors.message && clearError(setErrors, "message");
                        }}
                        className="form-control-soft textarea-160 form-control"
                      />
                      {errors.message && (
                        <Form.Text className="text-danger">
                          {errors.message.message}
                        </Form.Text>
                      )}
                    </Form.Group>

                    <div>
                      <Button
                        type="submit"
                        className="btn btn-orange-lg px-4"
                        disabled={submitting}
                      >
                        {submitting ? "Sending..." : "Send Message"}
                      </Button>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>

            {/* RIGHT: You can add contact details map or info here */}
            <Col lg={6}>
              <Row className="g-3 person-card-section">
                {committeMembers.length > 0 &&
                  committeMembers.slice(0, 5).map((c) => (
                    <Col key={c._id} xs={12}>
                      <PersonCard
                        img={
                          c?.picture_path
                            ? `${IMG_PATH}${c.picture_path}`
                            : defaultAvatar
                        }
                        name={c?.name}
                        role={c?.position}
                        phone={c?.phone}
                      />
                    </Col>
                  ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      <section>
        <Container className="my-4">
          <Row className="align-items-center cta-section py-5 mx-auto">
            <Col sm={12} md={9} lg={9} className="px-lg-5 px-md-4 px-4 py-1">
              <h5 className="mb-3 cta-title fw-bold">
                Would You Like to Support Us?
              </h5>
              <p className="mb-0 cta-text fw-regular">
                Along with reaching out to us, you can also support our ongoing efforts through a donation.
                Every contribution helps us serve the community better.
              </p>
            </Col>
            <Col
              sm={12}
              md={3}
              lg={3}
              className="text-md-end mt-md-3 mt-4 mt-md-0 px-lg-5 px-md-4 px-4 py-1"
            >
              <Button
                className="btn btn-orange-md"
                onClick={() => navigate("/donate")}
              >
                Donate
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
